import { useContext } from 'react';
import { ApiContext } from '../../../context/ApiContext';
import { FaStar, FaRegStar } from "react-icons/fa";
import { ProgressBar } from 'react-bootstrap';
import { DashboardContext } from '../../../context/DashboardContext';

export default function SemTituloTI({ corFavorito }) {
    const { SwotTiRelatorio } = useContext(ApiContext)
    const { AdicionarGraficoFavorito } = useContext(DashboardContext)
    return (
        <>
            <h2 className="h2-bsc">
                <button onClick={() => AdicionarGraficoFavorito("Análise Capacidades de TI")} className='btn-grafico'>{corFavorito("Análise Capacidades de TI") ? <FaRegStar /> : <FaStar style={{ color: 'orange' }} />}</button>
                <span style={{ fontWeight: '500' }}>Análise Capacidades de TI</span>
            </h2>
            <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: '25px' }}>
                <div style={{ border: '1px solid #e4e4e7', borderRadius: '8px', width: '100%' }}>
                    <div style={{ padding: '16px', borderBottom: '1px solid #e4e4e7' }}>
                        <span className="span-swot span-swot-green">Análise das forças</span>
                    </div>
                    <div className="modal-body-swot titulo-fases" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        {SwotTiRelatorio && SwotTiRelatorio?.forcas && SwotTiRelatorio?.forcas.length > 0 ?
                            SwotTiRelatorio?.forcas
                                ?.sort((a, b) => {
                                    if (b.gut === a.gut) {
                                        return a.capacidadeNegocioDemanda.titulo.localeCompare(b.capacidadeNegocioDemanda.titulo);
                                    }
                                    return b.gut - a.gut;
                                })
                                .map((item, index) => {
                                    return (
                                        <div style={{ width: '100%' }} key={index}>
                                            <div className='span-bsc' style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '5px' }}>
                                                <span style={{ fontWeight: 600 }}>{item.capacidadeNegocioDemanda.titulo}</span>
                                                <span>{item.gut}</span>
                                            </div>
                                            <ProgressBar min={0} max={125} id='progress-forca' now={item.gut} style={{ width: '100%' }} />
                                        </div>
                                    )
                                })
                            :
                            <p>Não foram adicionadas forças a esse SWOT.</p>
                        }
                    </div>
                </div>
                <div style={{ border: '1px solid #e4e4e7', borderRadius: '8px', width: '100%' }}>
                    <div style={{ padding: '16px', borderBottom: '1px solid #e4e4e7' }}>
                        <span className="span-swot span-swot-red">Análise das fraquezas</span>
                    </div>
                    <div className="modal-body-swot titulo-fases" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        {SwotTiRelatorio && SwotTiRelatorio?.fraquezas && SwotTiRelatorio?.fraquezas.length > 0 ?
                            SwotTiRelatorio?.fraquezas
                                ?.sort((a, b) => {
                                    if (b.gut === a.gut) {
                                        return a.capacidadeNegocioDemanda.titulo.localeCompare(b.capacidadeNegocioDemanda.titulo);
                                    }
                                    return b.gut - a.gut;
                                })
                                .map((item, index) => {
                                    return (
                                        <div style={{ width: '100%' }} key={index}>
                                            <div className='span-bsc' style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '5px' }}>
                                                <span style={{ fontWeight: 600 }}>{item.capacidadeNegocioDemanda.titulo ? item.capacidadeNegocioDemanda.titulo : '-'}</span>
                                                <span>{item.gut}</span>
                                            </div>
                                            <ProgressBar min={0} max={125} id='progress-fraqueza' now={item.gut} style={{ width: '100%' }} />
                                        </div>
                                    )
                                })
                            :
                            <p>Não foram adicionadas fraquezas a esse SWOT.</p>
                        }
                    </div>
                </div>
                <div style={{ border: '1px solid #e4e4e7', borderRadius: '8px', width: '100%' }}>
                    <div style={{ padding: '16px', borderBottom: '1px solid #e4e4e7' }}>
                        <span className="span-swot span-swot-blue">Análise das oportunidade</span>
                    </div>
                    <div className="modal-body-swot titulo-fases" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        {SwotTiRelatorio && SwotTiRelatorio?.oportunidades && SwotTiRelatorio?.oportunidades.length > 0 ?
                            SwotTiRelatorio?.oportunidades
                                ?.sort((a, b) => {
                                    if (b.gut === a.gut) {
                                        return a.capacidadeNegocioDemanda.titulo.localeCompare(b.capacidadeNegocioDemanda.titulo);
                                    }
                                    return b.gut - a.gut;
                                })
                                .map((item, index) => {
                                    return (
                                        <div style={{ width: '100%' }} key={index}>
                                            <div className='span-bsc' style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '5px' }}>
                                                <span style={{ fontWeight: 600 }}>{item.capacidadeNegocioDemanda.titulo ? item.capacidadeNegocioDemanda.titulo : '-'}</span>
                                                <span>{item.gut}</span>
                                            </div>
                                            <ProgressBar min={0} max={125} id='progress-oportunidade' now={item.gut} style={{ width: '100%' }} />
                                        </div>
                                    )
                                })
                            :
                            <p>Não foram adicionadas oportunidades a esse SWOT.</p>
                        }
                    </div>
                </div>

                <div style={{ border: '1px solid #e4e4e7', borderRadius: '8px', width: '100%' }}>
                    <div style={{ padding: '16px', borderBottom: '1px solid #e4e4e7' }}>
                        <span className="span-swot span-swot-yellow">Análise das ameaças</span>
                    </div>
                    <div className="modal-body-swot titulo-fases" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        {SwotTiRelatorio && SwotTiRelatorio?.ameacas && SwotTiRelatorio?.ameacas.length > 0 ?
                            SwotTiRelatorio?.ameacas
                                ?.sort((a, b) => {
                                    if (b.gut === a.gut) {
                                        return a.capacidadeNegocioDemanda.titulo.localeCompare(b.capacidadeNegocioDemanda.titulo);
                                    }
                                    return b.gut - a.gut;
                                })
                                .map((item, index) => {
                                    return (
                                        <div style={{ width: '100%' }} key={index}>
                                            <div className='span-bsc' style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '5px' }}>
                                                <span style={{ fontWeight: 600 }}>{item.capacidadeNegocioDemanda.titulo ? item.capacidadeNegocioDemanda.titulo : '-'}</span>
                                                <span>{item.gut}</span>
                                            </div>
                                            <ProgressBar min={0} max={125} id='progress-ameaca' now={item.gut} style={{ width: '100%' }} />
                                        </div>
                                    )
                                })
                            :
                            <p>Não foram adicionadas ameaças a esse SWOT.</p>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}